<template>
    <el-container v-loading.fullscreen.lock="fullscreenLoading">
        <el-header height="90px">
            <el-row :gutter="20">
                <!-- 用户信息 -->
                <el-col :span="6">
                    <!-- <div><b>Type:</b> <span>{{ user.loginType }}</span></div>
                    <div><b>Username:</b> <span>{{ user.username }}</span></div>
                    <div><b>Email:</b> <span>{{ user.email }}</span></div>
                    <div><b>VIP:</b> <span>{{ user.isVIP }}</span></div> -->
                    <div style="position:relative;top:25px;">
                        <img src="../assets/images/logo.svg" />
                        <span style="font-size:12px;position:absolute;z-index:1;left:80px;top:30px;">The Go-To Choice
                            for Cloud-to-Cloud Data</span>
                    </div>
                </el-col>
                <!-- 添加云盘 -->
                <el-col :span="18" style="display:flex;justify-content:right;align-items:center;margin-top:25px;">
                    <el-button v-for="cloud in clouds" :key="cloud" @click="readyAddDrive(cloud)">
                        <div :class="'drive-icon-' + cloud"
                            style="width:24px;height:24px;display:inline-block;background-size:24px;vertical-align:middle;">
                        </div>
                        <span style="vertical-align:middle;display:inline-block;height:24px;line-height:24px;">{{ cloud
                            }}</span>
                    </el-button>
                </el-col>
            </el-row>
        </el-header>
        <el-container>
            <!-- 云盘列表 -->
            <el-aside width="260px">
                <div class="drive-item" v-for="drive in drives" :key="drive.id" @click="openDrive(drive.id)"
                    :class="curDriveId == drive.id ? 'selected' : ''">
                    <div :class="'drive-icon-' + drive.type"
                        style="width:24px;height:24px;display:inline-block;background-size:24px;vertical-align:middle;">
                    </div>
                    <span style="vertical-align:middle;">{{ drive.name }}</span>
                    <el-tooltip effect="light" placement="right">
                        <template slot="content">
                            <el-button @click="infoDrive(drive.id)">Detail</el-button>
                            <el-button @click="deleteDrive(drive.id)">Delete</el-button>
                        </template>
                        <i class="el-icon-more"></i>
                    </el-tooltip>
                </div>
            </el-aside>
            <el-main>
                <!-- 文件管理 -->
                <div class="main-left">
                    <!-- 创建任务 -->
                    <div class="create-task">
                        <div>
                            <el-row :gutter="10">
                                <el-col :span="5">
                                    <el-select v-model="taskParam.type" placeholder="Type" style="width:110px;">
                                        <el-option label="Transfer" value="tran"></el-option>
                                        <el-option label="Sync" value="sync"></el-option>
                                        <el-option label="Backup" value="backup"></el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="5">
                                    <el-input v-model="taskParam.name" placeholder="Name"></el-input>
                                </el-col>
                                <el-col :span="5">
                                    <el-input v-model="taskParam.param.options.threadCountList"
                                        placeholder="List"></el-input>
                                </el-col>
                                <el-col :span="5">
                                    <el-input v-model="taskParam.param.options.threadCount"
                                        placeholder="Run"></el-input>
                                </el-col>
                                <el-col :span="4">
                                    <el-button @click="createTask" style="margin-top:10px;">Create Task</el-button>
                                </el-col>
                            </el-row>
                        </div>
                        <div style="margin:10px 0px;">
                            <el-button @click="selectTaskNodeFrom">Set From</el-button>
                            <span v-if="taskParam.fdid">{{ getDrive(taskParam.fdid).name +
                                getNodePath(taskParam.param.from)
                            }}</span>
                        </div>
                        <div>
                            <el-button @click="selectTaskNodeTo">Set To</el-button>
                            <span v-if="taskParam.tdid">{{ getDrive(taskParam.tdid).name +
                                getNodePath(taskParam.param.to)
                            }}</span>
                        </div>
                    </div>
                    <!-- 导航 -->
                    <el-breadcrumb class="folder-nav" separator-class="el-icon-arrow-right" v-if="curDriveId">
                        <el-breadcrumb-item>
                            <span class="folder-nav-span" @click="openFolder(curDriveId, null, null)">{{
                                getDrive(curDriveId).name
                            }}</span>
                            <el-button v-if="curStart"
                                @click="openFolder(curDriveId, curNode, curStart)">Next</el-button>
                        </el-breadcrumb-item>
                        <el-breadcrumb-item v-for="node in getNodeArr(curNode)" :key="node.id">
                            <span class="folder-nav-span" @click="openFolder(curDriveId, node, null)">{{ node.name
                            }}</span>
                            <el-button v-if="curStart"
                                @click="openFolder(curDriveId, curNode, curStart)">Next</el-button>
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                    <!-- 表格 -->
                    <el-table :data="curResult" highlight-current-row ref="filesTable"
                        @current-change="handleCurrentChange">
                        <el-table-column label="Name" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <i v-if="scope.row.dir" class="el-icon-folder"></i>
                                <i v-else class="el-icon-document"></i>
                                <span v-if="scope.row.dir" class="item-folder"
                                    @click="openFolder(curDriveId, scope.row, null)">{{ scope.row.name }}</span>
                                <span v-else>{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Size" width="100px">
                            <template slot-scope="scope">
                                {{ formatBytes(scope.row.size) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="Date" width="150px">
                            <template slot-scope="scope">
                                {{ formatDate(scope.row.time) }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 任务列表 -->
                <div class="main-right">
                    <!-- 单个任务 -->
                    <div class="task-item" v-for="task in tasks" :key="task.id">
                        <!-- 任务类型和名称 -->
                        <div class="task-type">
                            <div v-if="task.type == 'tran'" class="cloudTransfer-black"></div>
                            <div v-if="task.type == 'sync'" class="cloudsync-black"></div>
                            <div v-if="task.type == 'backup'" class="cloudbackup-black"></div>
                            <el-tooltip effect="light" placement="bottom">
                                <template slot="content">
                                    <div>Create: {{ formatDate(task.ctime) }}</div>
                                    <div>Upadte: {{ formatDate(task.ctime) }}</div>
                                </template>
                                <span>{{ task.name }}</span>
                            </el-tooltip>
                        </div>
                        <!-- 任务来源和目标 -->
                        <div style="height:80px;margin-top:50px;padding-bottom:50px;border-bottom:1px solid #d3dcf0;">
                            <el-row :gutter="20">
                                <!-- 来源 -->
                                <el-col :span="8" style="display:flex;justify-content:right;align-items:center;">
                                    <div style="text-align:center;">
                                        <!-- 源云盘图标 -->
                                        <div :class="'drive-icon-' + getDrive(task.fdid).type"
                                            style="width:60px;height:60px;">
                                        </div>
                                        <el-tooltip effect="light" placement="bottom">
                                            <!-- 源云盘路径 -->
                                            <template slot="content">
                                                <el-breadcrumb class="folder-nav" separator="/">
                                                    <el-breadcrumb-item v-for="node in getNodeArr(task.param.from)"
                                                        :key="node.id">
                                                        <span class="folder-nav-span"
                                                            @click="openFolder(task.fdid, node, null)">{{
                                                                node.name
                                                            }}</span>
                                                    </el-breadcrumb-item>
                                                </el-breadcrumb>
                                            </template>
                                            <!-- 源云盘名称 -->
                                            <div class="task-from-to" @click="openFolder(task.fdid, null, null)">{{
                                                getDrive(task.fdid).name }}</div>
                                        </el-tooltip>
                                    </div>
                                </el-col>
                                <!-- 任务中间的图标 -->
                                <el-col :span="8" style="display:flex;justify-content:center;align-items:center;">
                                    <el-tooltip effect="light" placement="bottom">
                                        <template slot="content">
                                            <div>List: {{ task.param.options.threadCountList }}</div>
                                            <div>Run: {{ task.param.options.threadCount }}</div>
                                        </template>
                                        <div class="double_arrow" style="margin-top:25px;"></div>
                                    </el-tooltip>
                                </el-col>
                                <!-- 目标 -->
                                <el-col :span="8" style="display:flex;justify-content:left;align-items:center;">
                                    <div style="text-align:center;">
                                        <!-- 目标云盘图标 -->
                                        <div :class="'drive-icon-' + getDrive(task.tdid).type"
                                            style="width:60px;height:60px;">
                                        </div>
                                        <el-tooltip effect="light" placement="bottom">
                                            <!-- 目标路径 -->
                                            <template slot="content">
                                                <el-breadcrumb class="folder-nav" separator="/">
                                                    <el-breadcrumb-item v-for="node in getNodeArr(task.param.to)"
                                                        :key="node.id">
                                                        <span class="folder-nav-span"
                                                            @click="openFolder(task.tdid, node, null)">{{
                                                                node.name
                                                            }}</span>
                                                    </el-breadcrumb-item>
                                                </el-breadcrumb>
                                            </template>
                                            <!-- 目标云盘名称 -->
                                            <div class="task-from-to" @click="openFolder(task.tdid, null, null)">{{
                                                getDrive(task.tdid).name }}</div>
                                        </el-tooltip>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div style="margin-top: 10px;">
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <!-- 任务状态 -->
                                    <div class="task-status" style="margin-top: 15px;">
                                        <i v-if="task.status == 'create'" class="el-icon-circle-plus"
                                            style="color:skyblue;"></i>
                                        <i v-if="task.status == 'pending'" class="el-icon-magic-stick"
                                            style="color:hotpink;"></i>
                                        <i v-if="task.status == 'running'" class="el-icon-loading"
                                            style="color:gray;"></i>
                                        <i v-if="task.status == 'cancelled'" class="el-icon-remove"
                                            style="color:gray;"></i>
                                        <i v-if="task.status == 'completed'" class="el-icon-success"
                                            style="color:green;"></i>
                                        <i v-if="task.status == 'failed'" class="el-icon-error" style="color:red;"></i>
                                        <i v-if="task.status == 'warn'" class="el-icon-warning"
                                            style="color:orange;"></i>
                                        <i v-if="task.status == 'error'" class="el-icon-s-release"
                                            style="color:red;"></i>
                                        <el-tooltip effect="light" placement="bottom">
                                            <template slot="content">
                                                <span>{{ task.msg }}</span>
                                            </template>
                                            <span @click="showTaskDetail(task)">
                                                <b>{{ task.status }}</b>
                                                <span class="task-line-info">{{ taskLineInfo(task) }}</span></span>
                                        </el-tooltip>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <!-- 操作任务的按钮 -->
                                    <div style="text-align:right;margin-top:10px;">
                                        <el-button v-if="!isRun(task.status)" @click="startTask(task.id)" type="primary"
                                            plain>
                                            <i class="el-icon-video-play"></i>
                                            <span>Start</span>
                                        </el-button>
                                        <el-button v-if="isRun(task.status)" @click="cancelTask(task.id)">
                                            <i class="el-icon-close"></i>
                                            <span>Cancel</span>
                                        </el-button>
                                        <el-button v-if="!isRun(task.status)" @click="deleteTask(task.id)" type="danger"
                                            plain>
                                            <i class="el-icon-delete"></i>
                                            <span>Delete</span>
                                        </el-button>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </el-main>
        </el-container>
        <!-- 添加云盘对话框 -->
        <el-dialog title="Add Cloud" :visible.sync="auth.show">
            <el-form :model="auth" label-width="100px">
                <!-- 一般云盘 -->
                <el-form-item label="Type">
                    <el-input v-model="auth.type" disabled></el-input>
                </el-form-item>
                <el-form-item label="Name">
                    <el-input v-model="auth.name"></el-input>
                </el-form-item>
                <!-- FTP -->
                <div v-if="auth.type == 'FTP'">
                    <el-form-item label="Protocol">
                        <el-select v-model="auth.ftp.protocol" placeholder="Protocol">
                            <el-option label="ftp-plain" value="ftp-plain"></el-option>
                            <el-option label="ftps-explicit" value="ftps-explicit"></el-option>
                            <el-option label="ftps-implicit" value="ftps-implicit"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Host">
                        <el-input v-model="auth.ftp.host"></el-input>
                    </el-form-item>
                    <el-form-item label="Port">
                        <el-input v-model="auth.ftp.port"></el-input>
                    </el-form-item>
                    <el-form-item label="Username">
                        <el-input v-model="auth.ftp.username"></el-input>
                    </el-form-item>
                    <el-form-item label="Password">
                        <el-input v-model="auth.ftp.password"></el-input>
                    </el-form-item>
                    <el-form-item label="Passive">
                        <el-switch v-model="auth.ftp.passive"></el-switch>
                    </el-form-item>
                    <el-form-item label="Encoding">
                        <el-select v-model="auth.ftp.encoding" placeholder="Encoding">
                            <el-option label="UTF-8" value="UTF-8"></el-option>
                            <el-option label="GBK" value="GBK"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Path">
                        <el-input v-model="auth.ftp.path"></el-input>
                    </el-form-item>
                </div>
                <!-- SFTP -->
                <div v-if="auth.type == 'SFTP'">
                    <el-form-item label="Host">
                        <el-input v-model="auth.sftp.host"></el-input>
                    </el-form-item>
                    <el-form-item label="Port">
                        <el-input v-model="auth.sftp.port"></el-input>
                    </el-form-item>
                    <el-form-item label="Username">
                        <el-input v-model="auth.sftp.username"></el-input>
                    </el-form-item>
                    <el-form-item label="Password">
                        <el-input v-model="auth.sftp.password"></el-input>
                    </el-form-item>
                    <el-form-item label="Private Key">
                        <el-input v-model="auth.sftp.privateKey" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="Passphrase">
                        <el-input v-model="auth.sftp.passphrase"></el-input>
                    </el-form-item>
                    <el-form-item label="Path">
                        <el-input v-model="auth.sftp.path"></el-input>
                    </el-form-item>
                </div>
                <!-- WebDAV -->
                <div v-if="auth.type == 'WebDAV'">
                    <el-form-item label="URL">
                        <el-input v-model="auth.webdav.url"></el-input>
                    </el-form-item>
                    <el-form-item label="Username">
                        <el-input v-model="auth.webdav.username"></el-input>
                    </el-form-item>
                    <el-form-item label="Password">
                        <el-input v-model="auth.webdav.password"></el-input>
                    </el-form-item>
                </div>
                <!-- MediaFire -->
                <div v-if="auth.type == 'MediaFire'">
                    <el-form-item label="Email">
                        <el-input v-model="auth.mediafire.email"></el-input>
                    </el-form-item>
                    <el-form-item label="Password">
                        <el-input v-model="auth.mediafire.password"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer">
                <el-button @click="auth.show = false">Cancel</el-button>
                <el-button type="primary" @click="addCloud()">Add</el-button>
            </div>
        </el-dialog>
        <!-- 云盘信息 -->
        <el-dialog title="Cloud Info" :visible.sync="driveInfo.show">
            <div v-if="driveInfo.used"><b>Used:</b> <span>{{ formatBytes(driveInfo.used) }}</span></div>
            <div v-if="driveInfo.total"><b>Total:</b> <span>{{ formatBytes(driveInfo.total) }}</span></div>
            <div v-if="driveInfo.email"><b>Email:</b> <span>{{ driveInfo.email }}</span></div>
            <div v-if="driveInfo.name"><b>Name:</b> <span>{{ driveInfo.name }}</span></div>
            <div v-if="driveInfo.ftp.host">
                <div><b>Protocol:</b> <span>{{ driveInfo.ftp.protocol }}</span></div>
                <div><b>Host:</b> <span>{{ driveInfo.ftp.host }}</span></div>
                <div><b>Port:</b> <span>{{ driveInfo.ftp.port }}</span></div>
                <div><b>Username:</b> <span>{{ driveInfo.ftp.username }}</span></div>
                <div><b>Passive:</b> <span>{{ driveInfo.ftp.passive }}</span></div>
                <div><b>Encoding:</b> <span>{{ driveInfo.ftp.encoding }}</span></div>
                <div><b>Path:</b> <span>{{ driveInfo.ftp.path }}</span></div>
            </div>
            <div v-if="driveInfo.sftp.host">
                <div><b>Host:</b> <span>{{ driveInfo.sftp.host }}</span></div>
                <div><b>Port:</b> <span>{{ driveInfo.sftp.port }}</span></div>
                <div><b>Username:</b> <span>{{ driveInfo.sftp.username }}</span></div>
                <div><b>Path:</b> <span>{{ driveInfo.sftp.path }}</span></div>
            </div>
            <div v-if="driveInfo.webdav.url">
                <div><b>URL:</b> <span>{{ driveInfo.webdav.url }}</span></div>
                <div><b>Username:</b> <span>{{ driveInfo.webdav.username }}</span></div>
            </div>
            <div v-if="driveInfo.mediafire.email">
                <div><b>Email:</b> <span>{{ driveInfo.mediafire.email }}</span></div>
            </div>
            <div slot="footer">
                <el-button @click="driveInfo.show = false">Close</el-button>
            </div>
        </el-dialog>
        <!-- 当前任务 -->
        <el-dialog v-if="curTask" :visible.sync="showCurTask" :title="'Task Details: ' + curTask.name" width="1000px">
            <!-- 状态 -->
            <div class="task-status" style="text-align:center;font-size:30px;font-weight:bold;">
                <i v-if="curTask.status == 'create'" class="el-icon-circle-plus" style="color:skyblue;"></i>
                <i v-if="curTask.status == 'pending'" class="el-icon-magic-stick" style="color:hotpink;"></i>
                <i v-if="curTask.status == 'running'" class="el-icon-loading" style="color:gray;"></i>
                <i v-if="curTask.status == 'cancelled'" class="el-icon-remove" style="color:gray;"></i>
                <i v-if="curTask.status == 'completed'" class="el-icon-success" style="color:green;"></i>
                <i v-if="curTask.status == 'failed'" class="el-icon-error" style="color:red;"></i>
                <i v-if="curTask.status == 'warn'" class="el-icon-warning" style="color:orange;"></i>
                <i v-if="curTask.status == 'error'" class="el-icon-s-release" style="color:red;"></i>
                <el-tooltip effect="light" placement="bottom">
                    <template slot="content">
                        <div>
                            <span><b>Task Msg:</b> {{ curTask.msg }}</span>
                        </div>
                        <div v-if="curTask.result.curMsg">
                            <span><b>Cur Msg:</b> {{ curTask.result.curMsg }}</span>
                        </div>
                        <div v-if="curTask.result.curNode">
                            <div>
                                <span><b>Cur Node:</b> {{ getNodePath(curTask.result.curNode) }}</span>
                            </div>
                            <div>
                                <span><b>Cur Node Msg:</b> {{ curTask.result.curNode.msg }}</span>
                            </div>
                        </div>
                    </template>
                    <span>{{ curTask.status }}</span>
                </el-tooltip>
            </div>
            <!-- 3项数据 -->
            <el-row :gutter="20" style="margin:20px 0px;">
                <!-- 个数 -->
                <el-col :span="9" style="display:flex;justify-content:right;align-items:center;">
                    <div style="text-align:center;">
                        <div style="margin-bottom:10px;">{{ (curTask.result.countSkip + curTask.result.countWarn +
                            curTask.result.countError +
                            curTask.result.countSuccess) + ' / ' +
                            (curTask.result.countSum) }}</div>
                        <el-tooltip effect="light" placement="bottom">
                            <template slot="content">
                                <span>{{ countTitle(curTask.result) }}</span>
                                <el-progress v-if="curTask.result.countSum" text-color="white" :text-inside="true"
                                    style="margin-bottom:10px;" :stroke-width="20"
                                    :percentage="parseFloat((countCur(curTask.result) / (curTask.result.countSum) * 100).toFixed(2))"></el-progress>
                            </template>
                            <b>Count</b>
                        </el-tooltip>
                    </div>
                </el-col>
                <!-- 大小 -->
                <el-col :span="6" style="display:flex;justify-content:center;align-items:center;">
                    <div style="text-align:center;">
                        <div style="margin-bottom:10px;">{{ formatBytes(curTask.result.sizeCur) + ' / ' +
                            formatBytes(curTask.result.sizeSum) }}
                        </div>
                        <el-tooltip effect="light" placement="bottom">
                            <template slot="content">
                                <div style="width:200px;text-align:center;">
                                    <div><b>Avg Speed: </b>{{ avgSpeed(curTask.result.startTime, curTask.result.endTime,
                                        curTask.result.sizeCur) }}</div>
                                    <el-progress v-if="curTask.result.sizeSum" text-color="white" :text-inside="true"
                                        :stroke-width="20"
                                        :percentage="parseFloat((curTask.result.sizeCur / curTask.result.sizeSum * 100).toFixed(2))"></el-progress>
                                </div>
                            </template>
                            <b>Size</b>
                        </el-tooltip>
                    </div>
                </el-col>
                <!-- 时间 -->
                <el-col :span="9" style="display:flex;justify-content:left;align-items:center;">
                    <div style="text-align:center;">
                        <div style="margin-bottom:10px;">{{ formatTime(curTask.result.endTime -
                            curTask.result.startTime) }}
                        </div>
                        <el-tooltip effect="light" placement="bottom">
                            <template slot="content">
                                <div>
                                    <div v-if="curTask.result.ttl"><span><b>TTL:</b> {{ formatTime(curTask.result.ttl)
                                    }}</span></div>
                                    <div><span><b>Start:</b> {{ formatDate(curTask.result.startTime) }}</span></div>
                                    <div><span><b>End:</b> {{ formatDate(curTask.result.endTime) }}</span></div>
                                </div>
                            </template>
                            <b>Time</b>
                        </el-tooltip>
                    </div>
                </el-col>
            </el-row>
            <!-- 正在执行的节点 -->
            <el-table v-if="curTask.status == 'running'" :data="curTask.result.runningFiles" border
                style="max-height:530px;overflow:auto;">
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column label="Running Files" show-overflow-tooltip width="680px">
                    <template slot-scope="scope">
                        <span>{{ getNodePath(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Msg" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.msg }}
                    </template>
                </el-table-column>
            </el-table>
            <!-- 错误列表 -->
            <el-table v-if="curTask.errors" :data="curTask.errors" border highlight-current-row
                style="height:400px;overflow:auto;">
                <el-table-column label="Error Files" show-overflow-tooltip width="400px">
                    <template slot-scope="scope">
                        <i v-if="scope.row.dir" class="el-icon-folder"></i>
                        <i v-else class="el-icon-document"></i>
                        <span>{{ getNodePath(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Size" width="100px">
                    <template slot-scope="scope">
                        {{ formatBytes(scope.row.size) }}
                    </template>
                </el-table-column>
                <el-table-column label="Warn" width="60px">
                    <template slot-scope="scope">
                        {{ scope.row.warn }}
                    </template>
                </el-table-column>
                <el-table-column label="Msg" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.msg }}
                    </template>
                </el-table-column>
                <el-table-column label="Trace" width="70px">
                    <template slot-scope="scope">
                        <span @click="traceInfo = scope.row.trace" class="show-trace">Show</span>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 堆栈信息 -->
            <pre v-if="traceInfo" class="trace-info">{{ traceInfo }}</pre>
            <!-- 关闭堆栈信息 -->
            <el-button v-if="traceInfo" @click="traceInfo = null" class="trace-close">
                <i class="el-icon-close"></i>
            </el-button>
        </el-dialog>
    </el-container>
</template>

<script>
import { Message } from "element-ui";
import requestUtils from '@/js/request_util.js';

export default {
    data() {
        return {
            // 任务进度定时器
            taskTimer: null,
            // 全屏加载
            fullscreenLoading: false,
            // 用户信息
            user: {},
            // 云盘列表
            drives: [],
            // 任务列表
            tasks: [],
            // 当前任务
            curTask: null,
            // 显示当前任务详情
            showCurTask: false,
            // 堆栈信息
            traceInfo: null,
            // 当前云盘ID
            curDriveId: "",
            // 当前节点
            curNode: null,
            // 当前开始位置
            curStart: null,
            // 当前节点的结果集
            curResult: [],
            // 当前行节点
            curRowNode: null,
            // 支持的云盘类型
            clouds: [
                "GoogleWorkspace",
                "GoogleDrive",
                "OneDrive",
                "Dropbox",
                "PCloud",
                "Box",
                "MediaFire",
                "WebDAV",
                "SFTP",
                "FTP",
            ],
            // 添加云盘参数
            auth: {
                show: false,
                type: "",
                name: "",
                ftp: {
                    protocol: "ftp-plain",
                    host: "",
                    port: 21,
                    username: "",
                    password: "",
                    passive: true,
                    encoding: "UTF-8",
                    path: "",
                },
                sftp: {
                    host: "",
                    port: 22,
                    username: "",
                    password: "",
                    privateKey: "",
                    passphrase: "",
                    path: "",
                },
                webdav: {
                    url: "",
                    username: "",
                    password: "",
                },
                mediafire: {
                    email: "",
                    password: "",
                },
            },
            // 云盘信息
            driveInfo: {
                show: false,
                used: null,
                total: null,
                email: null,
                name: null,
                ftp: {
                    protocol: null,
                    host: null,
                    port: null,
                    username: null,
                    passive: null,
                    encoding: null,
                    path: null,
                },
                sftp: {
                    host: null,
                    port: null,
                    username: null,
                    path: null,
                },
                webdav: {
                    url: null,
                    username: null,
                },
                mediafire: {
                    email: null,
                },
            },
            // 创建任务参数
            taskParam: {
                type: "tran",
                name: "Task 1",
                fdid: "",
                tdid: "",
                param: {
                    from: null,
                    to: null,
                    options: {
                        excludeNames: [],
                        allowedExtensions: [],
                        fromNodeHasSameName: false,
                        toNodeHasSameName: false,
                        threadCount: 10,
                        threadCountList: 3,
                    },
                },
            },
        }
    },
    mounted() {
        // 初始化，加载用户信息
        this.loadUser(() => {
            // 初始化，加载云盘信息
            this.loadDrives(() => {
                // 初始化，检查云盘添加结果
                let flag = this.checkAddCloudResult();
                if (!flag && this.drives.length > 0) {
                    // 打开第一个云盘
                    this.openDrive(this.drives[0].id);
                }
                // 初始化，加载任务信息
                this.listTasks(() => {
                    this.taskTimer = setInterval(() => {
                        this.loadTaskProg();
                    }, 3000);
                });
            });
        });
    },
    beforeDestroy() {
        if (this.taskTimer) {
            clearInterval(this.taskTimer);
            this.taskTimer = null;
        }
    },
    methods: {
        // 任务简单信息
        taskLineInfo(task) {
            if (task.status == 'running') {
                const result = task.result;
                if (result.listDone) {
                    let percentage = '0%'
                    if (result.countSum == 1) {
                        percentage = (result.sizeCur / result.sizeSum * 100).toFixed(2) + '%';
                    } else {
                        percentage = ((result.countSkip + result.countWarn + result.countError + result.countSuccess) / result.countSum * 100).toFixed(2) + '%';
                    }
                    const avgStr = this.avgSpeed(result.startTime, result.endTime, result.sizeCur);
                    return percentage + ' ' + avgStr;
                } else {
                    return 'Count:' + result.countSum + ' Size:' + this.formatBytes(result.sizeSum);
                }
            } else {
                return '';
            }
        },
        // 显示任务详情
        showTaskDetail(task) {
            this.curTask = task;
            if (this.hasErrors(task)) {
                this.getTaskErrors(this.curTask);
            }
            this.traceInfo = null;
            this.showCurTask = true
        },
        // 平均速度
        avgSpeed(startTime, endTime, sizeCur) {
            const duration = (endTime - startTime) / 1000
            if (duration == 0) {
                return this.formatBytes(sizeCur) + '/s'
            } else {
                return this.formatBytes(sizeCur / duration) + '/s'
            }
        },
        // 格式化时间
        formatTime(millis) {
            if (!millis || millis < 0) return "-";
            let totalSeconds = Math.floor(millis / 1000);
            const days = Math.floor(totalSeconds / (24 * 3600));
            totalSeconds %= (24 * 3600);
            const hours = Math.floor(totalSeconds / 3600);
            totalSeconds %= 3600;
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;
            let result = "";
            if (days > 0) result += days + "d";
            if (hours > 0) result += hours + "h";
            if (minutes > 0) result += minutes + "m";
            if (seconds > 0 || result === "") result += seconds + "s";
            return result;
        },
        // 个数title
        countTitle(result) {
            return "Skip:" + result.countSkip + ",Warn:" + result.countWarn + ",Error:" + result.countError + ",Success:" + result.countSuccess + ",Sum:" + result.countSum;
        },
        // 已完成个数
        countCur(result) {
            return result.countSkip + result.countWarn + result.countError + result.countSuccess;
        },
        // 有错误
        hasErrors(task) {
            if (this.isDone(task.status)) {
                return task.result.countWarn + task.result.countError > 0;
            }
            return false;
        },
        // 已完成
        isDone(status) {
            return status == 'cancelled' || status == 'completed' || status == 'failed' || status == 'warn' || status == 'error';
        },
        // 在运行
        isRun(status) {
            return status == 'pending' || status == 'running';
        },
        // 获取
        getTask(taskId) {
            return this.tasks.find(task => task.id === taskId) || null;
        },
        // 加载任务进度
        loadTaskProg() {
            if (this.tasks.length == 0) return;
            this.sendRequest("/task/progress", {}, (data) => {
                for (let i = 0; i < data.length; i++) {
                    let task = this.getTask(data[i].id);
                    if (task) {
                        task.msg = data[i].msg;
                        task.result = data[i].result;
                        task.status = data[i].status;
                    }
                }
            })
        },
        // 获取任务错误信息
        getTaskErrors(task) {
            const taskId = task.id;
            this.sendRequest("/task/errors", { id: taskId }, (data) => {
                task.errors = data;
            })
        },
        // 取消任务
        cancelTask(taskId) {
            this.sendRequest("/task/cancel", { id: taskId }, () => {
                this.listTasks();
            })
        },
        // 启动任务
        startTask(taskId) {
            this.sendRequest("/task/start", { id: taskId }, () => {
                this.listTasks();
            })
        },
        // 获取任务列表
        listTasks(callback) {
            this.sendRequest("/task/list", {}, (data) => {
                this.tasks = data;
                if (callback) callback();
            })
        },
        // 删除任务
        deleteTask(taskId) {
            this.sendRequest("/task/delete", { id: taskId }, () => {
                this.listTasks();
            })
        },
        // 文件列表选择行
        handleCurrentChange(row) {
            this.curRowNode = row;
        },
        // 选择任务节点
        selectTaskNode() {
            if (this.curRowNode) {
                return this.curRowNode;
            } else {
                return this.curNode;
            }
        },
        // 选择任务节点来源
        selectTaskNodeFrom() {
            this.taskParam.fdid = this.curDriveId;
            this.taskParam.param.from = this.selectTaskNode();
            this.$refs.filesTable.setCurrentRow(null);
        },
        // 选择任务节点目标
        selectTaskNodeTo() {
            this.taskParam.tdid = this.curDriveId;
            this.taskParam.param.to = this.selectTaskNode();
            this.$refs.filesTable.setCurrentRow(null);
        },
        // 创建任务
        createTask() {
            // 未设置任务名称
            if (!this.taskParam.name) {
                Message.error("Please input task name");
                return;
            }
            // 未选择源
            if (!this.taskParam.fdid) {
                Message.error("Please select source cloud");
                return;
            }
            // 未选择目标
            if (!this.taskParam.tdid) {
                Message.error("Please select destination cloud");
                return;
            }
            // 非传输任务源只能是文件夹
            let from = this.taskParam.param.from;
            if (from && !from.dir && this.taskParam.type != 'tran') {
                Message.error("The source of non-transfer tasks can only be a folder");
                return;
            }
            // 目标只能是文件夹
            let to = this.taskParam.param.to;
            if (to && !to.dir) {
                Message.error("Task targets can only be folders");
                return;
            }
            // 开始创建任务
            this.sendRequest("/task/create", this.taskParam, () => {
                this.listTasks();
            })
        },
        // 格式化字节数
        formatBytes(value) {
            if (value === null || value === undefined) return '-';
            if (value === 0) return '0B';
            const k = 1024;
            const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
            const i = Math.floor(Math.log(value) / Math.log(k));
            return (value / Math.pow(k, i)).toFixed(2) + sizes[i];
        },
        // 格式化时间
        formatDate(value) {
            if (!value) return '';
            const date = new Date(value);
            if (isNaN(date.getTime())) return '';
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        // 获取云盘
        getDrive(id) {
            for (let i = 0; i < this.drives.length; i++) {
                let drive = this.drives[i];
                if (drive.id === id) {
                    return drive;
                }
            }
            return null;
        },
        // 获取节点路径
        getNodePath(node) {
            let path = '';
            let arr = this.getNodeArr(node);
            for (let i = 0; i < arr.length; i++) {
                let item = arr[i];
                path += '/' + item.name;
            }
            return path;
        },
        // 获取节点和父
        getNodeArr(node) {
            let arr = [];
            while (node) {
                arr.push(node);
                node = node.parent;
            }
            return arr.reverse();
        },
        // 展开云盘根目录
        openDrive(id) {
            this.openFolder(id, null, null);
        },
        // 展开文件夹
        openFolder(id, node, start) {
            if (node && !node.dir) return;
            this.sendRequest("/file/list", { id: id, param: { node: node, start: start } }, (data) => {
                this.curDriveId = id;
                this.curNode = node;
                this.curStart = data.next;
                let nodes = data.nodes;
                // 绑定父关系
                for (let i = 0; i < nodes.length; i++) {
                    let temp = nodes[i];
                    temp.parent = node;
                }
                this.curResult = nodes;
            })
        },
        // 检查云盘添加结果
        checkAddCloudResult() {
            const url = window.location.href;
            const params = new URL(url).searchParams;
            const resultBase64 = params.get("result");
            if (resultBase64) {
                try {
                    var result = new TextDecoder().decode(Uint8Array.from(atob(resultBase64), c => c.charCodeAt(0)));
                    var json = JSON.parse(result);
                    if (json.status == "success") {
                        // 添加成功
                        var deiveId = json.data;
                        // 并且打开
                        this.openDrive(deiveId);
                    } else {
                        // 添加失败原因
                        Message.error(json.data);
                    }
                } catch (e) {
                    // 解析失败
                    Message.error(resultBase64)
                }
                return true;
            }
            return false;
        },
        // 准备添加云盘
        readyAddDrive(cloud) {
            this.auth.type = cloud;
            this.auth.name = cloud;
            this.auth.show = true;
        },
        // 云盘信息
        infoDrive(id) {
            this.sendRequest("/drive/info", { id: id }, (data) => {
                this.driveInfo.used = 0;
                this.driveInfo.total = 0;
                this.driveInfo.email = null;
                this.driveInfo.name = null;
                this.driveInfo.ftp = {};
                this.driveInfo.sftp = {};
                this.driveInfo.webdav = {};
                this.driveInfo.mediafire = {};
                Object.assign(this.driveInfo, data);
                this.driveInfo.show = true;
            })
        },
        // 删除云盘
        deleteDrive(id) {
            this.sendRequest("/drive/delete", { id: id }, () => {
                this.loadDrives();
            })
        },
        // 加载云盘
        loadDrives(callback) {
            this.sendRequest("/drive/list", {}, (data) => {
                this.drives = data;
                if (callback) {
                    callback();
                }
            })
        },
        // 添加云盘
        addCloud() {
            this.auth.show = false;
            this.sendRequest("/drive/auth", this.auth, (data) => {
                if (data.type == "url") {
                    // 需要跳转授权
                    location.href = data.data;
                } else {
                    // 已经成功，重新加载
                    this.loadDrives(() => {
                        // 并且打开
                        this.openDrive(data.data.id);
                    });
                }
            })
        },
        // 加载用户信息
        loadUser(callback) {
            this.sendRequest("/user/load", {}, (data) => {
                this.user = data;
                if (callback) {
                    callback();
                }
            })
        },
        // 发送Lite请求
        sendRequest(path, data, callback) {
            const noLoadingPaths = ["/task/progress"];
            if (noLoadingPaths.indexOf(path) == -1) {
                this.fullscreenLoading = true;
            }
            requestUtils.doLiteRequest(path, data)
                .then(res => {
                    if (noLoadingPaths.indexOf(path) == -1) {
                        this.fullscreenLoading = false;
                    }
                    let code = res.code
                    let msg = res.msg
                    if (msg == undefined) {
                        msg = res.message;
                    }
                    if (code == 200) {
                        // 请求成功
                        if (callback) {
                            callback(res.data)
                        }
                    } else if (code == 400) {
                        // 请求失败
                        Message.warning(msg)
                    } else {
                        if (msg == "Unauthorized") {
                            // 未登录
                            location.href = location.host.includes("localhost") ? "http://localhost:8080/share/123" : "https://" + location.host + "/sign"
                        } else {
                            // 服务器异常
                            Message.error(msg)
                        }
                    }
                }, err => {
                    if (noLoadingPaths.indexOf(path) == -1) {
                        this.fullscreenLoading = false;
                    }
                    // 请求异常
                    Message.error(err)
                });
        }
    }
}
</script>

<style scoped>
/* 根 */
.el-container {
    height: 100%;
    position: relative;
}

/* 顶部 */
.el-header {
    color: #FFF;
    background-color: #293166;
}

/* 左侧 */
.el-aside {
    background-color: #dce4f5;
}

/* 主体 */
.el-main {
    background-color: #f2f7fe;
    height: 100%;
}

/* 文件列表 */
.main-left {
    width: 49%;
    height: 100%;
    float: left;
    overflow: auto;
    padding-bottom: 100px;
    box-sizing: border-box;
}

/* 任务列表 */
.main-right {
    width: 50%;
    height: 100%;
    float: right;
    overflow: auto;
    padding-bottom: 90px;
    box-sizing: border-box;
}

/* 云盘项 */
.drive-item {
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    cursor: default;
}

.drive-item:hover {
    background-color: #f2f7fe;
}

.drive-item.selected {
    background-color: #f2f7fe;
}

/* 云盘项-更多图标 */
.drive-item i {
    float: right;
    margin: 10px;
    cursor: pointer;
}

/* 文件夹项 */
.item-folder {
    cursor: pointer;
}

.item-folder:hover {
    text-decoration: underline;
}

/* 文件夹导航 */
.folder-nav {
    margin: 10px 0;
}

/* 文件夹导航项 */
.folder-nav-span {
    cursor: pointer;
}

.folder-nav-span:hover {
    text-decoration: underline;
}

/* 创建任务 */
.create-task {
    padding: 10px;
    background-color: #FFF;
    border: 1px solid #dce4f5;
}

/* 按钮 */
.el-button {
    height: 40px;
}

/* 任务项 */
.task-item {
    padding: 20px;
    margin-bottom: 10px;
    background-color: #FFF;
    border: 1px solid #dce4f5;
}

/* 错误项 */
.error-item {
    padding: 10px;
    margin-top: 10px;
    border: 1px solid #dce4f5;
    max-height: 500px;
    overflow: auto;
}

.error-item pre {
    margin: 0px;
}

/* 任务类型图标 */
.task-type>div {
    display: inline-block;
    vertical-align: middle;
}

/* 任务名称 */
.task-type>span {
    margin-left: 10px;
    vertical-align: middle;
    font-size: 24px;
    font-weight: bold;
}

/* 任务来源目标云盘名称 */
.task-from-to {
    cursor: pointer;
    margin-top: 5px;
}

.task-from-to:hover {
    text-decoration: underline;
}

/* 任务状态 */
.task-status {
    margin-top: 10px;
    font-size: 20px;
}

.task-status>span:hover {
    cursor: pointer;
    text-decoration: underline;
}

.task-status>* {
    vertical-align: middle;
}

/* 任务运行简单信息 */
.task-line-info {
    font-size: 14px;
}

/* 显示堆栈信息 */
.show-trace {
    color: #293166;
    cursor: pointer;
}

.show-trace:hover {
    text-decoration: underline;
}

/* 堆栈信息 */
.trace-info {
    position: absolute;
    z-index: 1;
    left: 20px;
    bottom: 18px;
    width: calc(100% - 40px);
    height: 400px;
    background-color: #FFF;
    border: 1px solid #293166;
    box-sizing: border-box;
    padding: 10px;
    overflow: auto;
}

/* 关闭堆栈信息 */
.trace-close {
    position: absolute;
    z-index: 1;
    bottom: 432px;
    right: 20px;
}

/* 云盘图标 */
.drive-icon-GoogleWorkspace {
    background-image: url("../assets/images/lite/drives/GoogleWorkspace.png");
}

.drive-icon-GoogleDrive {
    background-image: url("../assets/images/lite/drives/GoogleDrive.png");
}

.drive-icon-OneDrive {
    background-image: url("../assets/images/lite/drives/OneDrive.png");
}

.drive-icon-Dropbox {
    background-image: url("../assets/images/lite/drives/Dropbox.png");
}

.drive-icon-PCloud {
    background-image: url("../assets/images/lite/drives/PCloud.png");
}

.drive-icon-Box {
    background-image: url("../assets/images/lite/drives/Box.png");
}

.drive-icon-MediaFire {
    background-image: url("../assets/images/lite/drives/MediaFire.png");
}

.drive-icon-WebDAV {
    background-image: url("../assets/images/lite/drives/WebDAV.png");
}

.drive-icon-SFTP {
    background-image: url("../assets/images/lite/drives/SFTP.png");
}

.drive-icon-FTP {
    background-image: url("../assets/images/lite/drives/FTP.png");
}
</style>


// WEBPACK FOOTER //
// src/components/mc_lite.vue